// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sx-0";